import { ThunkAction } from 'redux-thunk';

import { State } from 'modules';

export * from './products';
export * from './models';
export * from './responses';
export * from './experiment';

export type StandardThunkAction<R = Promise<void>, E = void> = ThunkAction<
  R,
  State,
  E
>;



// WEBPACK FOOTER //
// ./app/gamma/src/types/index.ts